import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export default class UploadedPdfApi {
    public static async createNew(formData: FormData) {
        let uploadedPdf;

        try {
            uploadedPdf =
                await ApiController.post(ApiRoutes.uploadedPdf.create, formData) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(uploadedPdf);
    }

    public static async updateExisting(file: any) {
        let uploadedPdf;

        const request = {
            data: {
                type: 'uploaded_pdfs',
                id: file.uid,
                attributes: {
                    title: file.title,
                },
            },
        };

        try {
            uploadedPdf =
                await ApiController.patch(ApiRoutes.uploadedPdf.update(file.uid), request) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(uploadedPdf);
    }

}
